import Header from "@/components/Header";
import Hero from "@/components/Hero";
// import Lights from "@/assets/background/lights.png";

export default function TopFold() {
  return (
    <section className="relative overflow-hidden">
      {/* 🎄 Desktop Lights */}
      {/* <img
        src={Lights}
        alt="Decorative lights"
        className="absolute w-full object-contain mix-blend-screen pointer-events-none hidden md:block"
        style={{
          top: "-190px",
          left: "12px",
          maxHeight: "500px",
          zIndex: 1,
        }}
      /> */}

      {/* 📱 Mobile Lights */}
      {/* <img
        src={Lights}
        alt="Decorative lights mobile"
        className="absolute w-full object-contain mix-blend-screen pointer-events-none md:hidden"
        style={{
          top: "-20px",
          left: "0px",
          maxHeight: "280px",
          opacity: 0.85,
          zIndex: 1,
        }}
      /> */}

      <Header />
      <Hero />
    </section>
  );
}
